import React from 'react';
import PropTypes from 'prop-types';

import { componentInvariants } from 'bloko/common/helpers/customPropTypes';

import 'bloko/blocks/icon/icon.less';

export default function IconLink({ Element, disabled, children, type, innerRef, ...iconLinkProps }) {
    const typeAttribute = {};

    if ((Element === 'button' || Element === 'input') && type) {
        typeAttribute.type = type;
    }

    return (
        <Element {...typeAttribute} {...iconLinkProps} className="bloko-icon-link" ref={innerRef} disabled={disabled}>
            {children}
        </Element>
    );
}

IconLink.propTypes = {
    /** Задизейбленная иконка ссылка  */
    disabled: PropTypes.bool,
    /** Тип элемента для Gap 'span', 'button', 'a', 'input' */
    Element: componentInvariants(['span', 'button', 'a', 'input']),
    /** Тип по назначению, если Element="button" | "input" */
    type: PropTypes.oneOf(['submit', 'button']),
    /** Функция для получения DOM элемента кнопки */
    innerRef: PropTypes.func,
    /** Контент */
    children: PropTypes.node,
};

IconLink.defaultProps = {
    disabled: false,
    Element: 'button',
    type: 'button',
};
